import styled from "styled-components";

import { DATA_E2E_KEY, type IStyledAttributes } from "@ryde/shared";
import { greyMui, MOBILE_BREAKPOINT, rydeColors } from "@ryde/theme";

import { TitleLineStyled } from "../../login/login.page.styled";

// styled.main: the consent page is a top-level route with no <main> ancestor in App, and every
// page must expose exactly one main landmark for assistive-technology navigation.
// grid-area: the page shares the login page grid (MainLoginContainerStyled); without it the grid
// auto-places this element into the first cell, underneath the fixed purple illustration.
export const OauthConsentFormStyled = styled.main.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "oauth-consent-form",
})`
  grid-area: loginform;
  width: 100%;
  max-width: 347px;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  .consentCard {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  .clientLogo {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    object-fit: contain;
  }

  .requestingAccess {
    font-size: 15px;
    line-height: 1.5;
  }

  .scopesTitle,
  .companyLabel {
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    color: ${greyMui._700};
    margin: 0;
  }

  .scopesList {
    margin: 0;
    padding-inline-start: 20px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 14px;
  }

  .companyRow {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .freshLoginNotice {
    font-size: 13px;
    color: ${rydeColors.steel};
  }

  .actions {
    display: flex;
    gap: 12px;
    margin-top: 8px;

    & > * {
      flex: 1 1 0;
    }
  }

  .statusMessage {
    font-size: 15px;
    text-align: center;
  }

  .errorMessage {
    font-size: 15px;
    text-align: center;
    color: ${greyMui._800};
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    justify-content: center;
    padding-inline-start: 15px;
    padding-inline-end: 15px;
  }
`;

/** The login page's title, under this screen's own data-e2e id. */
export const OauthConsentTitleStyled = styled(
  TitleLineStyled,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "oauth-consent-title",
})``;
